import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9","key":"svg-0"}],["path",{"d":"M17 12a5 5 0 1 0 -5 5","key":"svg-1"}]]

const IconLoader3 = createReactComponent('outline', 'loader-3', 'Loader3', __iconNode);

export default IconLoader3;